import React from 'react';

const Content = (props) => (
      <section className={`pt-3 rest-of-screen ${props.className}`}>
        {props.children}
      </section>
    );

export default Content;
